import * as boReport from './boReport';

const reducers = {
  ...boReport,
};
 
export default reducers;
